// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "v-deep .el-date-editor[data-v-581bfc22] {\n  width: 100% !important;\n}", ""]);
// Exports
module.exports = exports;
